import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { CheckCircle, Eye, EyeSlash, XCircle } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Validation from "../../../../hooks/Validation";
import { activateUser } from "../../../../store/actions/adminAction";
import { adminReset } from "../../../../store/reducerSlice/admin";
import Loader from "../../../common/loader/Loader";
import ApiResponsePopup from "../../../common/modal/ApiResponsePopup";
import Styles from "../../../Login/LoginForm.module.css";
const formElements = [
  {
    key: "newPassword",
    label: "Password",
    placeHolder: "Enter password",
    type: "password",
  },
  {
    key: "confirmPassword",
    label: "Confirm Password",
    placeHolder: "Enter confirm password",
    type: "password",
  },
];

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const UserActivationForm = () => {
  const navigate = useNavigate();
  const { activationKey } = useParams();
  const [passwordDetail, setPasswordDetail] = useState({
    newPassword: null,
    confirmPassword: null,
  });
  const [eyes, setEyes] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const [successMessage, setSuccessMessage] = useState(null);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [activationKeyNotExist, setActivationKeyNotExist] = useState(null);

  const [privacyChecked, setPrivacyChecked] = useState(true);
  const [termsChecked, setTermsChecked] = useState(true);
  const handlePrivacyChange = (event) => {
    setPrivacyChecked(event.target.checked);
  };

  const handleTermsChange = (event) => {
    setTermsChecked(event.target.checked);
  };
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation(passwordDetail);
  const dispatch = useDispatch();
  const {
    adminDetail,
    isLoader,
    isRecordAdded,
    error: apiError,
  } = useSelector((state) => state.admin);

  const submitHandler = (e) => {
    e.preventDefault();
    // Check if the checkboxes are checked
    if (!privacyChecked || !termsChecked) {
      alert(
        "Please check the Policy-Notice and Terms & Conditions checkboxes."
      );
    } else {
      checkValidator();
      setIsActionCalled(true);
    }
  };

  useEffect(() => {
    if (!isError() && error !== null && isActionCalled) {
      const { newPassword } = passwordDetail;
      dispatch(
        activateUser({
          password: newPassword,
          activationKey,
        })
      ).then(({ payload }) => {
        if (payload?.success) {
          setSuccessMessage(payload?.message);
          setTimeout(() => {
            hideHandlerRes();
          }, 3000);
        }
      });
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  const hideHandlerRes = () => {
    dispatch(adminReset());
    navigate("/login");
  };

  useEffect(() => {
    return () => {
      dispatch(adminReset());
      dispatch(
        activateUser({
          activationKey,
        })
      ).then(({ payload }) => {
        if (!payload?.success) {
          setActivationKeyNotExist(payload?.message);
          setTimeout(() => {
            hideHandlerRes();
          }, 3000);
        }
      });
    };
  }, []);

  return (
    <Form
      onSubmit={(e) => submitHandler(e)}
      style={{ maxWidth: 600, margin: "0 auto" }}
      noValidate
    >
      <h1 className={Styles.h1}>Setup Your Account</h1>
      {isLoader && <Loader />}
      {apiError && (
        <Alert variant={"danger"}>
          {apiError?.message || "Access denied! Please try again"}
        </Alert>
      )}

      {successMessage && <Alert variant={"success"}>{successMessage}</Alert>}
      {activationKeyNotExist ? (
        ""
      ) : (
        <>
          {formElements.map((element, i) => {
            return (
              <Form.Group
                className="mb-4 rowField"
                controlId="formBasicEmail"
                key={i}
              >
                <Form.Label>
                  {element.label} <span className="required">*</span>
                </Form.Label>
                <Form.Control
                  type={eyes[element.key] ? "text" : element.type}
                  name={element.key}
                  placeholder={element.placeHolder}
                  value={passwordDetail && passwordDetail[element.key]}
                  onChange={(e) => {
                    setPasswordDetail({
                      ...passwordDetail,
                      [element.key]: e.target.value,
                    });
                    // resetValidator(e.target.name);
                    //element.key === 'newPassword' &&
                    // checkValidator(element.key)
                  }}
                  onKeyUp={(e) => {
                    if (
                      element.key === "newPassword" &&
                      passwordDetail?.confirmPassword != null
                    ) {
                      checkValidator();
                    } else {
                      checkValidator(element.key);
                    }
                  }}
                  isInvalid={
                    error &&
                    error !== null &&
                    typeof error[element.key] !== "object" &&
                    error[element.key]
                  }
                />
                {element.key !== "email" ? (
                  <div
                    className="eyeIcon"
                    onClick={(e) =>
                      setEyes({
                        ...eyes,
                        [element.key]: !eyes[element.key],
                      })
                    }
                  >
                    {eyes[element.key] ? <Eye /> : <EyeSlash />}
                  </div>
                ) : null}
                <Form.Control.Feedback type="invalid">
                  {error &&
                    error !== null &&
                    typeof error[element.key] !== "object" &&
                    error[element.key]}
                </Form.Control.Feedback>
                {element.key === "newPassword" && (
                  <Form.Text
                    className={`passwordRules ${
                      error && passwordDetail[element.key] && "valid"
                    }`}
                  >
                    <h3>Your password must have:</h3>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.lowercase &&
                            error[element.key]?.lowercase
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.lowercase ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one lowercase letter
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.uppercase &&
                            error[element.key]?.uppercase
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.uppercase ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one UPPERCASE letter
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.number &&
                            error[element.key]?.number
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.number ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one number
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.special &&
                            error[element.key]?.special
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.special ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one special character
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.length &&
                            error[element.key]?.length
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.length ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least 8 characters
                    </p>
                  </Form.Text>
                )}
              </Form.Group>
            );
          })}
          <div className="requiredNote">
            Note: You must complete all the mandatory fields.
          </div>
          <br />
          <Form.Group className="mb-3" controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              checked={privacyChecked}
              onChange={handlePrivacyChange}
              label={
                <span>
                  <a href="/privacy-notice" target="_blank">
                    Privacy-Notice
                  </a>
                </span>
              }
            />
            <Form.Check
              type="checkbox"
              checked={termsChecked}
              onChange={handleTermsChange}
              label={
                <span>
                  <a href="/terms-and-conditions" target="_blank">
                    Terms-and-Conditions
                  </a>
                </span>
              }
            />
          </Form.Group>
          <Button
            className="btn-primary border-0"
            type="submit"
            style={{
              fontSize: "14px",
              height: "48px",
              filter: "drop-shadow()",
              boxShadow: "1px 4px 8px 1px rgba(133, 93, 217, 0.5)",
            }}
          >
            Activate
          </Button>
        </>
      )}
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordAdded,
          title: "Successfully Activated",
          successMsg: "User Activated Successfully",
          updateMsg: "Password successfully updated!",
        }}
      />
    </Form>
  );
};

export default UserActivationForm;
